import {
    getRegistration,
    listRegistrations
} from './queries';
import {
    createRegistration,
    deleteRegistration,
    updateRegistration,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Registration} from "../types.ts";
import {generateClient} from "aws-amplify/api";
import {
    notifyError,
    notifySuccess
} from "../../../components/ServiceNotifications.tsx";


export type ListRegistrations = {
    listRegistrations: { items: Registration[] }
}

export type GetRegistration = {
    getRegistration: Registration
}

export type CreateRegistration = {
    createRegistration: Registration
}

export type UpdateRegistration = {
    updateRegistration: Registration
}

export type DeleteRegistration = {
    deleteRegistration: string
}


const client = generateClient();


export const fetchRecords = async (filter: object) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListRegistrations>>({
                                                                                   query: listRegistrations,
                                                                                   variables: {filter: filter},
                                                                               });
        return response.data?.listRegistrations.items;
    } catch (e) {
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetRegistration>>({
                                                                                 query: getRegistration,
                                                                                 variables: {id: id},
                                                                             });
        return response.data?.getRegistration;
    } catch (e) {
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateRegistration>>({
                                                                                    query: createRegistration,
                                                                                    variables: {input: payload},
                                                                                });
        console.debug('in the service response', response);
        notifySuccess('Registration added successfully');
        return response.data?.createRegistration;
    } catch (e) {
        notifyError(e)
    }
};

export const update = async (id: string, record: Registration) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateRegistration>>({
                                                                                    query: (updateRegistration),
                                                                                    variables: {input: record},
                                                                                });
        notifySuccess('Registration updated successfully');
        return response.data?.updateRegistration;
    } catch (e) {
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteRegistration>>({
                                                                                    query: (deleteRegistration),
                                                                                    variables: {input: {id: id}},

                                                                                });
        notifySuccess('Registration deleted successfully');
        return response.data?.deleteRegistration;
    } catch (e) {
        notifyError(e)
    }
};
